import React from 'react'

const Purchases = () => {
  return (
    <div className='container-Sections'>
      <div className='container mbt-10em'>
        <div className='row mb-5'>
          <div className='col'>
            <h3 className='text-center font-weight-bold'>Condiciones de Uso</h3>
          </div>
        </div>
        <div className='row'>
          <div className='col'>
            <p className='pt-3 text-justify'>
              Al realizar una compra en lafloristeriahn.com, el usuario
              comprende que:
            </p>
          </div>
        </div>
        <div className='row'>
          <div className='col'>
            <p className='pt-3 text-justify'>
              I. Es posible que sea necesario realizar una sustitución en
              función de la temporada, la disponibilidad de flores u otras
              circunstancias imprevistas o incontrolables. El Cliente autoriza
              las sustituciones dentro de una paleta de colores específica. Las
              sustituciones necesarias serán a discreción del diseñador floral.
            </p>
          </div>
        </div>
        <div className='row'>
          <div className='col'>
            <p className='pt-3 text-justify'>
              II. Al realizar una compra en La Floristería Honduras, usted
              acepta que: (i) todas las afirmaciones fácticas que haya hecho en
              el proceso de compra y / o registro serán verdaderas y correctas;
              y (ii) no registrará una cuenta en nombre de ningún tercero ni
              utilizará la cuenta de un tercero en su nombre. Usted es el único
              responsable de la actividad que ocurre en sus cuentas personales,
              y debe mantener la confidencialidad de las contraseñas de su
              cuenta. Debe notificarnos de inmediato en caso de que se haya
              comprometido la seguridad de su contraseña. La Floristería
              Honduras no será responsable de sus pérdidas causadas por el uso
              no autorizado de su cuenta.
            </p>
          </div>
        </div>

        <div className='row'>
          <div className='col'>
            <p className='pt-3 text-justify'>
              III. Únicamente podrá comprar productos que estén publicados para
              su venta y cuyos detalles aparezcan en el sitio web.
            </p>
          </div>
        </div>
        <div className='row'>
          <div className='col'>
            <p className='pt-3 text-justify'>
              IV. Los detalles de los productos disponibles para su compra
              (incluyendo su correspondiente precio) se encuentran especificados
              en la tienda en línea de La Floristería Honduras
            </p>
          </div>
        </div>
        <div className='row'>
          <div className='col'>
            <p className='pt-3 text-justify'>
              V. Todos los precios de los productos mostrados en el sitio web
              incluyen ISV.
            </p>
          </div>
        </div>
        <div className='row'>
          <div className='col'>
            <p className='pt-3 text-justify'>
              VI. Una vez que el cliente de la tienda en línea
              lafloristeriahn.com haya seleccionado los productos que desee
              adquirir, dichos productos serán incluidos en la carretilla de
              compra, es responsabilidad del cliente verificar los datos
              introducidos y seleccionados en la compra.
            </p>
          </div>
        </div>
        <div className='row'>
          <div className='col'>
            <p className='pt-3 text-justify'>
              VII. Los productos o servicios y los precios ofrecidos en el sitio
              web, no necesariamente coincidirán con los productos, servicios y
              precios ofrecidos en la sala de venta de La Floristería Honduras.
            </p>
          </div>
        </div>
        <div className='row'>
          <div className='col'>
            <p className='pt-3 text-justify'>
              VIII. El precio que se deberá pagar por cada artículo adquirido
              será el precio publicado por cada artículo en el sitio web al
              momento de la compra en línea.
            </p>
          </div>
        </div>
        <div className='row'>
          <div className='col'>
            <p className='pt-3 text-justify'>
              IX. Las ofertas y promociones en la Tienda en línea
              lafloristeriahn.com, tienen validez, mientras estén publicadas en
              la misma.
            </p>
          </div>
        </div>
        <div className='row'>
          <div className='col'>
            <p className='pt-3 text-justify'>
              X. El usuario de la Tienda en línea lafloristeriahn.com tiene
              derecho a cancelar cualquier pedido que haya realizado y recibir
              el reembolso de su dinero, siempre que realice la cancelación
              dentro de un período de 24 horas después de la compra y 24 horas
              antes del de la hora de entrega.
            </p>
          </div>
        </div>
        <div className='row'>
          <div className='col'>
            <p className='pt-3 text-justify'>
              XI. Para cancelar o anular un pedido, por favor, contacte con
              nosotros al correo de servicio al cliente.
            </p>
          </div>
        </div>
        <div className='row'>
          <div className='col'>
            <p className='pt-3 text-justify'>
              XII. El máximo de compra en la tienda en línea es $700.00 dólares
              de los Estados Unidos de América.
            </p>
          </div>
        </div>
        <div className='row'>
          <div className='col'>
            <p className='pt-3 text-justify'>
              XIII. Los horarios de la tienda son de Lunes a Sábado de 8:00 am a
              05:00 pm Pedidos procesados fuera de esos horarios serán
              programados automáticamente para el siguiente día laboral, a menos
              que el cliente especifique una fecha de entrega próxima. Si es
              necesario entrega a domicilio en día Domingo debe hacerse el
              pedido el día sábado antes de mediodía.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Purchases
